(function ($) {
    'use strict';

    $('.js-extra-text').each(function() {
        var $container = $(this);

        $container.on('click', '.js-extra-text-toggle', function () {
            $container.addClass('active');
        });
    });

    $('.js-img-input').each(function() {
        var $panel = $(this).find('.js-image-input-panel');
        var $input = $(this).find('.js-image-input-container input[type=file]');
        $panel.on('click', function() {
            $input.trigger('click');
        });
        $input.on('change', function (e) {
            if ($input.val() && $input.get(0).files[0]) {
                $panel.css({
                    'background-image': 'url(' + URL.createObjectURL($input.get(0).files[0]) + ')'
                }).addClass('filled');
            }
        });
    });

    $('.js-vacancy-popup-container .js-popup-overlay').each(function() {
        var $t = $(this);
        $t.appendTo('body').addClass('active');

        var closePopup = function() {
            $t.remove();
            window.location.href = '/job';
        };

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $t.hasClass('active')) {
                closePopup();
            }
        });

        $t.on('click', function(e) {
            if ($(e.target).hasClass('js-popup-close') || $(e.target).hasClass('js-popup-overlay')) {
                closePopup();
            }
        });
    });
})(jQuery);
